import { useQuery } from "@tanstack/react-query";
import { GetAllBooks } from "../api/Books/GetAllBooks";
import BookCard from "../components/Home/BookCard";
import Spinner from "../components/Shared/Spinner";
import { Helmet } from "react-helmet";
import BooksHeader from "../components/Books/BooksHeader";

const AllBooks = () => {
    const { data: BooksResponse, isLoading: isBookLoading } = useQuery({
        queryFn: GetAllBooks,
        queryKey: ["books"],
        staleTime: 0,
        refetchInterval: 0,
    });
    const books = BooksResponse?.data?.bookData || [];

    return (
        <>
            <BooksHeader />
            <div className="pb-32 pt-20 container">
                <Helmet>
                    <link rel="canonical" href="https://www.nilewisect.com/books" />
                    <meta name="robots" content="index, follow" />
                    <meta name="description" content="Prepare for the CMA test with our comprehensive CMA course. Gain the knowledge and skills needed to excel and become a Certified Management Accountant." />
                    <meta name="title" content="CMA Test Preparation: Comprehensive CMA Course Online" />
                </Helmet>

                    <div className="flex md:mb-14 mb-8 pb-0.5 items-center justify-center sm:gap-10 gap-2 bg-gray-100 rounded-full w-fit mx-auto sm:px-10 px-5 sm:h-20  h-[70px]">
                        <div
                            className={`flex transition-all items-center justify-center duration-300 font-bold  sm:text-xl  w-full sm:w-auto cursor-pointer gap-2 bg-secondary/20 rounded-full px-4 py-2 text-secondary `}
                        >
                            <p>Books</p> <div className={` sm:text-base flex items-center justify-center text-sm size-6 text-center rounded-full   text-white bg-secondary`}>{books.length}</div>
                        </div>

                    </div>

                <div>
                    {isBookLoading ? (
                        <div className="min-h-[50vh] flex items-center justify-center">
                            <Spinner />
                        </div>
                    ) : (
                        <>
                            {books.length > 0 ? (
                                <div className="grid lg:grid-cols-3 sm:grid-cols-2 grid-cols-1 md:gap-x-8 gap-x-4 gap-y-5 sm:gap-y-8 md:gap-y-12">
                                    {books.map((book) => (
                                        <BookCard key={book.id} book={book} />
                                    ))}
                                </div>
                            ) : (
                                <div className="text-center my-10">
                                    <h2 className="text-lg text-burntBlack">No Books available for this category.</h2>
                                </div>
                            )}
                        </>
                    )
                    }

                </div>
            </div>
        </>
    )
}

export default AllBooks